module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "job-single-content section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "single-content1"
  }, [_c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Assistant Executive - Production/ Quality Control")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "forth-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-content2 py-4"
  }, [_c('h4', [_vm._v("Senior Laravel Developer "), _c('br'), _vm._v("It Park International, USA")]), _vm._v(" "), _c('p', [_vm._v("Senectus non fames aenean montes fringilla. Ipsum phasellus sagittis porttitor quam malesuada montes molestie sollicitudin eleifend dis diam dapibus aenean suspendisse elit pretium, varius pharetra natoque penatibus aptent. Proin neque.")])]), _vm._v(" "), _c('div', {
    staticClass: "single-content3 py-4"
  }, [_c('h4', [_vm._v("vacancy")]), _vm._v(" "), _c('span', {
    staticClass: "ml-4"
  }, [_vm._v("03")])]), _vm._v(" "), _c('div', {
    staticClass: "single-content4 py-4"
  }, [_c('h4', [_vm._v("job responsibility")]), _vm._v(" "), _c('p', [_vm._v("Senectus non fames aenean montes fringilla. Ipsum phasellus sagittis porttitor quam malesuada montes molestie sollicitudin eleifend dis diam dapibus aenean suspendisse elit pretium, varius pharetra natoque penatibus aptent. Proin neque.")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Mate dropped a clanger cuppa I chinwag  one plastered cheesed.")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Mate dropped a clanger cuppa I chinwag  one plastered.")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Dropped a clanger cuppa I chinwag  one plastered chee")]), _vm._v(" "), _c('li', [_vm._v("Cuppa I chinwag  one plastered cheesed.")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-content5 py-4"
  }, [_c('h4', [_vm._v("Educational Requirements")]), _vm._v(" "), _c('p', [_vm._v("Diploma in Engineering in Computer Science & Engineering, Bachelor in Engineering (BEngg) in Engineering (BEngg) in Computer Science & Enginetering")]), _vm._v(" "), _c('p', [_vm._v("Skills Required: JavaScript,PHP,WordPress,HTML5 & CSS3")])]), _vm._v(" "), _c('div', {
    staticClass: "single-content6 py-4"
  }, [_c('h4', [_vm._v("employment status")]), _vm._v(" "), _c('span', [_vm._v("Part Time/Full Time")])]), _vm._v(" "), _c('div', {
    staticClass: "single-content7 py-4"
  }, [_c('h4', [_vm._v("other benifits")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-3"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Mate dropped a clanger cuppa I chinwag  one plastered cheesed.")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Mate dropped a clanger cuppa I chinwag  one plastered.")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Dropped a clanger cuppa I chinwag  one plastered chee")]), _vm._v(" "), _c('li', [_vm._v("Cuppa I chinwag  one plastered cheesed.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "single-item mb-4"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("jobs type")]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Full Time")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Part Time")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Internship")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-item mb-4"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("job by location")]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("New York")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("California")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Swizerland")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Canada")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Sweden")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-item mb-4"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("salary range")]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("$20,000-$30,000")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("$25,000-$45,000")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("$40,000-$70,000")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-item"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("filter by salary")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "range",
      "value": "",
      "name": "range"
    }
  })])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "newsletter-area job-single section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("Get job information daily")]), _vm._v(" "), _c('p', [_vm._v("Subscribe to our newsletter and get a coupon code!")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('input', {
    attrs: {
      "type": "email",
      "placeholder": "Your email here",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Your email here'",
      "required": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("subscribe now")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-725c44d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/JobSingle.vue
// module id = 264
// module chunks = 1